/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecimalApiRespModel } from '../../models/decimal-api-resp-model';

export interface ApiMasterPromotionCodeValidateGet$Params {
  code?: string;
  total?: number;
}

export function apiMasterPromotionCodeValidateGet(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeValidateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DecimalApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeValidateGet.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('total', params.total, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DecimalApiRespModel>;
    })
  );
}

apiMasterPromotionCodeValidateGet.PATH = '/api/Master/PromotionCode/Validate';
